import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { CanWeHelp, MuiButton } from '../../components'
import { useGlobalStore } from '../../store'
import { MenuItem, Typography } from '@mui/material'
import { changePassword, logout } from '../../assets/images/icons'
import ChangePassword from '../changePassword'
import { Modal } from '..'
import { ListItemTextNew, AvatarWrapper, AvatarIcon, MenuWrapper, BorderWrapper } from './style'
// TooltipWrapper

const LayoutHeaderMenu = () => {
  const navigate = useHistory()
  const { user } = useGlobalStore()
  const [anchorElUser, setAnchorElUser] = useState(null)
  const [userimageUrl, setUserimageUrl] = useState()
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false)
  const [showCloseButton, setShowCloseButton] = useState(true)
  // const [showChangePasswordModal, setShowChangePasswordModal] = useState(false)

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget)
  }

  const handleCloseUserMenu = () => {
    setShowChangePasswordModal(false)
    setAnchorElUser(null)
  }

  const handleOnLogout = () => {
    localStorage.clear()
    navigate.push('/')
  }

  const handleOnChangePassword = () => {
    setAnchorElUser(null)
    setShowChangePasswordModal((prev) => !prev)
  }

  useEffect(() => {
    if (user?.UsingDefaultPassword) {
      setShowCloseButton(false)
      setShowChangePasswordModal(true)
    }
  }, [])

  return (
    <>
      {user?.UserName && (
        // <TooltipWrapper title={'Testing'} placement='right'>
        <AvatarWrapper>
          {userimageUrl && user ? (
            <AvatarIcon
              alt={user?.UserName || ''}
              button='true'
              onClick={handleOpenUserMenu}
              src={userimageUrl}
            />
          ) : (
            <AvatarIcon alt={user?.UserName || ''} button='true' onClick={handleOpenUserMenu}>
              {user?.UserName?.slice(0, 2).toUpperCase() || ''}
            </AvatarIcon>
          )}
        </AvatarWrapper>
        // </TooltipWrapper>
      )}

      <MenuWrapper
        className='menuWrapper'
        anchorEl={anchorElUser}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        <BorderWrapper>
          {user && <ListItemTextNew primary={user?.UserName} secondary={user?.UserEmail || ''} />}
          <MuiButton
            color='primary'
            variant='text'
            onClick={handleOnChangePassword}
            startIcon={<img src={changePassword} alt='' />}
            label='Change Password'
          />
          <MuiButton
            color='primary'
            variant='text'
            onClick={handleOnLogout}
            startIcon={<img src={logout} alt='' />}
            label='Logout'
          />
        </BorderWrapper>
      </MenuWrapper>

      {showChangePasswordModal && (
        <Modal title='' showClose={showCloseButton} onClose={handleOnChangePassword}>
          <ChangePassword onClose={handleCloseUserMenu} />
        </Modal>
      )}
    </>
  )
}

export default LayoutHeaderMenu
